// @ts-ignore
import _ from 'lodash';
import { ajax } from 'utils';
import { PromiseAction } from '../types/promiseAction';
import * as api from 'services/javaApi';

export const GET_USER_INFO_SUCCESS = 'mpc/account/get_user_info_success';
export const USER_LOGIN_OUT_SUCCESS = 'mpc/account/user_log_out_success';
export const GET_USER_SUPPLIER_LIST = 'mpc/account/get_user_supplier_list';

export interface GetUserInfoSuccess {
  type: typeof GET_USER_INFO_SUCCESS;
  data?: object;
}
export interface UserLogoutSuccess {
  type: typeof USER_LOGIN_OUT_SUCCESS;
}

export interface GetUserSupplierList {
  type: typeof GET_USER_SUPPLIER_LIST;
  data: [];
}

export type AccountActions = GetUserInfoSuccess | UserLogoutSuccess | GetUserSupplierList;

export function getUserInfo(querystring: { id?: string }): PromiseAction {
  return {
    types: [null, GET_USER_INFO_SUCCESS, null],
    promise: () => querystring.id
      ? api.outsourceAccountsLoginWithUrl(querystring).then(() => api.outsourceAccountsUserInfo())
      : api.outsourceAccountsUserInfo().catch((error: any) => {
          return {
            res_code: 0,
            res_msg: error.message,
          };
        }),
  };
}

export function userLogin(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () => api.outsourceSessionsLogin(body).catch((error: any) => {
      return {
        res_code: 0,
        res_msg: error.message,
      };
    }),
  };
}

export function userLogout(): PromiseAction {
  return {
    types: [null, USER_LOGIN_OUT_SUCCESS, null],
    promise: () => api.outsourceSessionsLoginOut()
  };
}

export function setLanguageTrunk(language: object) {
  return {
    types: [null, null, null],
    promise: () => ajax({
      url: 'v1/accounts/set_language',
      method: 'POST',
      body: { language },
    }),
    language,
  };
}

export function setLanguage(language: object) {
  return (dispatch: any, getState: any) => {
    const id = _.get(getState(), `account.id`);
    return dispatch(setLanguageTrunk(language)).then((res: any) => {
      if (res.res_code === 1) {
        dispatch(getUserInfo(id));
      }
    });
  };
}

export function modifyPwd(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () => api.outsourceSessionsModifyPassword(body),
  };
}

export function forgetPwd(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () => api.outsourceSessionsForgetPassword(body).catch((error: any) => {
      return {
        res_code: 0,
        res_msg: error.message,
      };
    }),
  };
}

export function resetPwd(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () => api.outsourceSessionsResetPassword(body).catch((error: any) => {
      return {
        res_code: 0,
        res_msg: error.message,
      };
    }),
  };
}

export function checkLink(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () => api.outsourceSessionsCheckResetLink(body).catch((error: any) => {
      return {
        res_code: -1,
        res_msg: error.message,
      };
    }),
  };
}
//  outsource/v2/suppliers
export function getSuppliersList() {
  return (dispatch: any, getState: any) => {
    return ajax({
      url: 'outsource/v2/java_proxy/supplier-new/list',
    }).then((res) => {
      dispatch({
        type: GET_USER_SUPPLIER_LIST,
        data: res.data || [],
      });
    });
  };
}

export function chooseSupplier(body: {
  supplier_id: number;
}): PromiseAction {
  return {
    types: [null, null, null],
    promise: () => api.outsourceSuppliersSetCurrent(body).catch((error: any) => {
      return {
        res_code: -1,
        res_msg: error.message,
      };
    }),
  };
}

export function isOpenNotification(flag: boolean) {
  return (dispatch: any) => {
    return dispatch({
      type: 'flag',
      data: flag
    })
  }
}
